export enum UploadsEndpoints {
  ROOT = '/upload',
  COMMON = '/common',
  PRE_SIGNED = '/presigned-url',
  ORDER = '/order',
}

export enum FileType {
  IMAGE = 'image',
  FILE = 'file',
}

export const staticUploadsEndpoints = {
  GET_COMMON_PRE_SIGNED: `${UploadsEndpoints.ROOT}${UploadsEndpoints.COMMON}${UploadsEndpoints.PRE_SIGNED}`,
};

export const getUploadsEndpoints = ({ id }: { id: string }) => ({
  GET_ORDER_PRE_SIGNED: `${UploadsEndpoints.ROOT}${UploadsEndpoints.ORDER}/${id}${UploadsEndpoints.PRE_SIGNED}`,
});

export interface IPresignedFile {
  url: string;
  asset_public_url: string;
  fields: Record<string, string>;
}

// ----------------- DTOs ----------------

export interface IGenericUploadDTO {
  type: FileType;
  file: File;
}

export interface IUploadOrderFileDTO extends IGenericUploadDTO {
  id: string;
}

export type IUploadCommonFileDTO = IGenericUploadDTO;

// ------------ Responses --------------

export type TPresignedFileResponse = IPresignedFile;
